import AdminNavBar from "./AdminNavBar";
import UnitsNavBar from "./UnitsNavBar";
const UnitsAdmin = () => {

	return (
		<div>
			<AdminNavBar />
			<UnitsNavBar />
		</div>
	)
};

export default UnitsAdmin;
